import { Menu, type MenuProps } from '@mui/material';

export interface PopoverProps extends MenuProps {
  children: React.ReactNode;
}
export const CustomMenu = ({ children, ...props }: PopoverProps) => {
  const { PaperProps: { sx: paperSx, ...restPaperProps } = {}, ...restProps } =
    props;

  return (
    <Menu
      transitionDuration={{ enter: 100, exit: 100 }}
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          '& .MuiDivider-root': {
            margin: '0 !important',
          },
          '& .MuiList-root': {
            p: 0,
          },
          ...paperSx,
        },
        ...restPaperProps,
      }}
      {...restProps}
    >
      {children}
    </Menu>
  );
};
